export const DROPDOWN_OPTIONS = [
  { value: 'RENAME', name: 'Rename' },
  {
    value: 'DELETE',
    name: 'Delete',
    additionalStyles: 'text-red-500 font-bold',
  },
];

export const WATCHLIST_DROPDOWN_OPTIONS = [
  { value: 'RENAME', name: 'Rename', disabled: true },
  { value: 'UNWATCH', name: 'Remove from Watchlist' },
  {
    value: 'DELETE',
    name: 'Delete',
    additionalStyles: 'text-red-500 font-bold',
  },
];
